import { Provider } from '@angular/core';
import { TICKET_BCP_REPOSITORY } from './application/ticket-bcp.tokens';
import { HttpTicketBcpRepository } from './infrastructure/http/http-ticket-bcp.repository';
import { GetTicketBcpDetailUseCase } from './application/get-ticket-bcp-detail.usecase';
import { RegisterTicketBcpUseCase } from './application/register-ticket-bcp.usecase';
import { UpdateTicketBcpFieldUseCase } from './application/update-ticket-bcp-field.usecase';

export const TICKET_BCP_PROVIDERS: Provider[] = [
  { provide: TICKET_BCP_REPOSITORY, useClass: HttpTicketBcpRepository },
  GetTicketBcpDetailUseCase,
  RegisterTicketBcpUseCase,
  UpdateTicketBcpFieldUseCase,
];
